/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingigreel2Inputs */

const en_crosspostingigreel2 = /** @type {(inputs: Crosspostingigreel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

const de_crosspostingigreel2 = /** @type {(inputs: Crosspostingigreel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reel`)
};

/**
* | output |
* | --- |
* | "Reel" |
*
* @param {Crosspostingigreel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingigreel2 = /** @type {((inputs?: Crosspostingigreel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingigreel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingigreel2(inputs)
	return de_crosspostingigreel2(inputs)
});
export { crosspostingigreel2 as "crosspostingIgReel" }